import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getDisabledUniteRegionalesRequest: ['response'],
    getDisabledUniteRegionalesSuccess: ['response', 'loading'],
    getDisabledUniteRegionalesFailure: ['error'],
})

export const getDisabledUniteRegionalesTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getDisabledUniteRegionalesSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getDisabledUniteRegionalesFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getDisabledUniteRegionalesRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_DISABLED_UNITE_REGIONALES_REQUEST]: getDisabledUniteRegionalesRequest,
    [Types.GET_DISABLED_UNITE_REGIONALES_SUCCESS]: getDisabledUniteRegionalesSuccess,
    [Types.GET_DISABLED_UNITE_REGIONALES_FAILURE]: getDisabledUniteRegionalesFailure,
})
